// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './views/App'
import router from './router'
import ElementUI from 'element-ui'
import axios from "axios";
import "@/assets/css/index.css";
import common from "./assets/api/common";
import apiAxios from "./assets/api/request";
import '@/assets/theme/index.css'
import '@/assets/theme/carousel.css'
import '@/assets/theme/dt_index.css'
import '@/assets/theme/bootstrap.css'
import ElTabPaneExt from 'el-tab-pane-ext'

Vue.use(ElementUI)
Vue.use(ElTabPaneExt)
Vue.use(common)
Vue.use(apiAxios)


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js